"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = void 0;
const core_1 = require("@emotion/core");
const styled_1 = __importDefault(require("@emotion/styled"));
const polished_1 = require("polished");
const getOutlineStyles = ({ disabled, loading, }) => ({ bg, border, color, text, }) => {
    return core_1.css `
    color: ${text || bg};
    background-color: transparent;
    border-color: ${border || bg};
    border-style: solid;
    border-width: 1px;

    ${!loading &&
        !disabled &&
        core_1.css `
        cursor: pointer;
        &:hover {
          color: ${color};
          background-color: ${polished_1.darken(0.05, bg)};
        }
        &:active {
          color: ${color};
          background-color: ${polished_1.darken(0.1, bg)};
        }
      `}
    
    ${disabled &&
        core_1.css `
        background-color: transparent;
        border-color: #758398;
        color: #758398;
        cursor: not-allowed;
      `}

    ${loading &&
        core_1.css `
        cursor: progress;
      `}
  `;
};
const getFilledStyles = ({ disabled, loading, }) => ({ bg, color, text, }) => {
    return core_1.css `
    color: ${text || color};
    background-color: ${bg};
    border-color: ${bg};
    border-style: solid;

    ${!loading &&
        !disabled &&
        core_1.css `
        cursor: pointer;
        &:hover {
          background-color: ${polished_1.darken(0.05, bg)};
          border-color: ${polished_1.darken(0.05, bg)};
        }
        &:active {
          background-color: ${polished_1.darken(0.1, bg)};
          border-color: ${polished_1.darken(0.1, bg)};
        }
      `}
    ${disabled &&
        core_1.css `
        cursor: not-allowed;
        background-color: ${polished_1.lighten(0.1, bg)};
        border-color: ${polished_1.lighten(0.1, bg)};
      `}
    ${loading &&
        core_1.css `
        cursor: progress;
      `};
  `;
};
const getStyles = ({ disabled, fill, loading, }) => {
    switch (fill) {
        case "filled":
            return getFilledStyles({ disabled, loading });
        case "outlined":
            return getOutlineStyles({ disabled, loading });
        default:
            return getFilledStyles({ disabled, loading });
    }
};
const getTypes = ({ disabled, fill, loading, theme, }) => {
    const { colors } = theme;
    const get = getStyles({
        disabled,
        fill,
        loading,
    });
    return {
        cancel: get({
            bg: colors.cancel,
            color: colors.white,
        }),
        default: get({
            bg: colors.background,
            border: colors.border,
            color: colors.text,
            text: colors.text,
        }),
        primary: get({
            bg: colors.primary,
            color: colors.white,
        }),
        success: get({
            bg: colors.success,
            color: colors.white,
        }),
    };
};
const getType = ({ color, disabled, fill, isLoading: loading, theme, }) => getTypes({
    disabled,
    fill,
    loading,
    theme,
})[color];
const StyledButton = styled_1.default.button `
  align-items: center;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  font-family: "Open sans", sans-serif;
  font-size: 16px;
  gap: 12px;
  outline: none;
  overflow: hidden;
  padding: 8px 16px;
  position: relative;
  text-align: center;
  transition: all 0.15s ease-in-out;
  width: fit-content;
  ${getType}
`;
exports.StyledButton = StyledButton;
